import { render, staticRenderFns } from "./PleaseWaitDialog.vue?vue&type=template&id=3bc632ee&scoped=true&"
import script from "./PleaseWaitDialog.vue?vue&type=script&lang=js&"
export * from "./PleaseWaitDialog.vue?vue&type=script&lang=js&"
import style0 from "./PleaseWaitDialog.vue?vue&type=style&index=0&id=3bc632ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc632ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
